import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  EmailOnboardApplicationSchema,
  EmailOnboardDraftSchema,
  EmailOnboardVerifyResponseSchema,
} from "../models";

const ApplicationCreateRequestSchema = z.object({
  brandDomain: z.string(),
  subDomain: z.string().optional().default(""),
  senderProfiles: z.array(
    z.object({
      name: z.string(),
      emailLocal: z.string(),
    }),
  ),
  replyTo: z.string().email(),
  dnsProvider: z.enum([
    "cloudflare",
    "godaddy",
    "google_cloud",
    "aws_route53",
    "other",
    "unknown",
  ]),
  dnsProviderOther: z.string().optional(),
  checkboxDnsPermission: z.boolean(),
  checkboxListConsent: z.boolean(),
  checkboxPolicyAgreement: z.boolean(),
});

const DraftRequestSchema = z.object({
  formData: z.record(z.unknown()),
});

export const api = makeApi([
  {
    alias: "getApplication",
    method: "get",
    path: "/api/v1/email-onboard/applications",
    response: EmailOnboardApplicationSchema.nullable(),
  },
  {
    alias: "createApplication",
    method: "post",
    path: "/api/v1/email-onboard/applications",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: ApplicationCreateRequestSchema,
      },
    ],
    response: EmailOnboardApplicationSchema,
  },
  {
    alias: "verifyApplication",
    method: "post",
    path: "/api/v1/email-onboard/applications/:applicationId/verify",
    parameters: [
      {
        type: "Path",
        name: "applicationId",
        schema: z.number(),
      },
    ],
    response: EmailOnboardVerifyResponseSchema,
  },
  {
    alias: "getDraft",
    method: "get",
    path: "/api/v1/email-onboard/drafts",
    response: EmailOnboardDraftSchema.nullable(),
  },
  {
    alias: "saveDraft",
    method: "post",
    path: "/api/v1/email-onboard/drafts",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: DraftRequestSchema,
      },
    ],
    response: EmailOnboardDraftSchema,
  },
  {
    alias: "deleteDraft",
    method: "delete",
    path: "/api/v1/email-onboard/drafts",
    response: z.void(),
  },
]);
